import { CurrencyCode } from '~/enums/CurrencyCode'

// Currencies the currency input accepts; the first is the default.
export const currencyConfig = {
  allowedCurrencies: [CurrencyCode.USD]
} as const
